/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Toast_DuplicateInputs */

const he_notifications_toast_duplicate = /** @type {(inputs: Notifications_Toast_DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`כבר יש לך התראה פעילה למוצר זה`)
};

const en_notifications_toast_duplicate = /** @type {(inputs: Notifications_Toast_DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You already have an active notification for this item`)
};

/**
* | output |
* | --- |
* | "You already have an active notification for this item" |
*
* @param {Notifications_Toast_DuplicateInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_toast_duplicate = /** @type {((inputs?: Notifications_Toast_DuplicateInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Toast_DuplicateInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_toast_duplicate(inputs)
	return en_notifications_toast_duplicate(inputs)
});